<template>
    <div class="col px-2 d-flex flex-column text-center mb-2">
        <div>{{ dia }}</div>

        <template v-for="(ag, ia) in value">
            <div class="input-group mt-1" :key="ia">
                <label class="form form-control d-flex align-items-center"
                    :class="'alert-' + cor(ag)">
                    <small class="d-inline-block text-nowrap text-truncate">
                        {{ ag.search }} 
                        <span class="text-muted">{{ ag.st_titulo }}</span>
                    </small>
                    <small class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" title="Procedimentos Habilitados" 
                        v-if="ag.agenda_procedimentos_count">
                        {{ ag.agenda_procedimentos_count }}
                    </small>
                    <small class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" title="Procedimentos Habilitados" 
                        v-else-if="ag.agenda_procedimentos && ag.agenda_procedimentos.filter(item => item.fl_ativo ).length">
                        {{ ag.agenda_procedimentos.filter(item => item.fl_ativo ).length }}
                    </small>
                    <small class="ml-2 text-warning" data-toggle="tooltip" data-placement="top" title="Nenhum procedimentos Habilitado" v-else>
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </small>
                </label>
                <div class="input-group-append">
                    <!-- :disabled="ag.disponibilidade < 0" -->
                    <button class="btn btn-sm" 
                        :class="'btn-' + cor(ag)"
                        type="button" id="button-addon2"
                        :disabled="$store.state.loading"
                        data-toggle="tooltip" data-placement="top" :title="ag.fl_ordem_chegada ? 'Agenda por Ordem de Chegada' : 'Agenda por Hora Marcada'"
                        @click="abrir (ag)">
                        <i class="fas fa-pen"></i>
                    </button>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
import $ from 'jquery';

export default {
    data () { 
        return { 

        }
    },

    props: ['value', 'dia'],

    methods: { 
        cor (ag) { 
            return ( ag.local && ag.local.fl_sala_paralela ) 
                ? 'info' 
                : ( ag.fl_ordem_chegada ? 'warning' : 'primary' );
        },

        abrir (ag) { 
            $('[data-toggle="tooltip"]').tooltip('dispose');
            this.$emit('click', ag);
        }
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    },

}
</script>